module.exports = __webpack_public_path__ + "img/shadow-dialog.e0d91a0e.png";